<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Image Preview</h5>
        <span class="modal-x-button" (click)="onClose()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </span>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-6 text-center">
                <h6>Desktop Image Preview</h6>
                <div class="image-container border rounded p-2 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <img *ngIf="data.desktopImage; else noDesktop" [src]="data.desktopImage" alt="UP" class="img-fluid" style="max-height: 500px;">
                    <ng-template #noDesktop>
                        <span class="text-muted">No Image</span>
                    </ng-template>
                </div>
            </div>
            <div class="col-6 text-center">
                <h6>Mobile Image Preview</h6>
                <div class="image-container border rounded p-2 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <img *ngIf="data.mobileImage; else noMobile" [src]="data.mobileImage" alt="MUP" class="img-fluid" style="max-height: 500px;">
                    <ng-template #noMobile>
                        <span class="text-muted">No Image</span>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
    </div>
</div>